export default __webpack_public_path__ + "static/media/bg.5d0b21c8.png";